module.exports = __webpack_public_path__ + "img/c08_buildingstartechbountifulharvest_Normal_ua.ae070c29.webp";